module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-up.faa2e8f0.svg";